var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.updateList.length > 0)?_c('div',_vm._l((_vm.getEntriesToShow),function(entry){return _c('calendar-bell-popup-entry',{key:entry.id,attrs:{"entry":entry,"last-entry":entry.id === _vm.updateList[_vm.updateList.length - 1].id},on:{"delete-entry":_vm.deleteEntry}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }